import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const EducationBreadcrumb = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;

    // Map of routes to display labels
    const breadcrumbMap = {
        "/educations": { label: "Masterclass Zajednica", home: true },
        "/educations/workshop": "Radionica",
        "/educations/workshop/fundamental": "Fundamental",
        "/educations/workshop/formation": "Formacije",
        "/educations/workshop/creative-formation": "Kreativna",
        "/educations/workshop/fade": "Fade",
        "/educations/beginner": "Početničke Edukacije",
        "/educations/beginner/nine-week": "9 Nedelja",
        "/educations/beginner/twelve-week": "12 Nedelja",
        "/educations/online": "Online",
        "/educations/single": "Radionica",
        "/educations/single/hands-on": "Hands On",
        "/educations/single/one-on-one": "Jedan na Jedan",
        "/educations/single/look-and-learn": "Look and Learn",
    };

    // Generate breadcrumbs from pathname
    const generateBreadcrumbs = () => {
        const pathSegments = pathname.split("/").filter((segment) => segment);
        const breadcrumbs = [];

        // Always add Home
        breadcrumbs.push({
            label: "Masterclass Zajednica",
            path: "/educations",
            isCurrent: pathname === "/educations",
        });

        let currentPath = "/educations";
        for (let i = 1; i < pathSegments.length; i++) {
            currentPath += "/" + pathSegments[i];
            const label = breadcrumbMap[currentPath];

            if (label && typeof label === "string") {
                breadcrumbs.push({
                    label,
                    path: currentPath,
                    isCurrent: pathname === currentPath,
                });
            }
        }

        return breadcrumbs;
    };

    const breadcrumbs = generateBreadcrumbs();

    // Only show breadcrumbs if on education pages
    if (!pathname.includes("/educations")) {
        return null;
    }

    return (
        <div
            style={{
                padding: "15px 20px",
                backgroundColor: "rgba(27, 29, 33, 0.6)",
                borderBottom: "1px solid #be9455",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "wrap",
            }}
        >
            {breadcrumbs.map((breadcrumb, index) => (
                <React.Fragment key={breadcrumb.path}>
                    <button
                        onClick={() => navigate(breadcrumb.path)}
                        style={{
                            background: "none",
                            border: "none",
                            color: breadcrumb.isCurrent ? "#be9455" : "#f3f3f3",
                            cursor: breadcrumb.isCurrent
                                ? "default"
                                : "pointer",
                            fontSize: "14px",
                            fontFamily: "Bebas Neue",
                            letterSpacing: "1px",
                            padding: "0",
                            transition: "color 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                            if (!breadcrumb.isCurrent) {
                                e.target.style.color = "#be9455";
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!breadcrumb.isCurrent) {
                                e.target.style.color = "#f3f3f3";
                            }
                        }}
                        disabled={breadcrumb.isCurrent}
                    >
                        {breadcrumb.label}
                    </button>
                    {index < breadcrumbs.length - 1 && (
                        <NavigateNextIcon
                            style={{
                                fontSize: "18px",
                                color: "#be9455",
                                margin: "0 4px",
                            }}
                        />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default EducationBreadcrumb;
